import React, {useContext} from 'react';
import {Redirect} from 'react-router-dom';
import {AuthContext} from '../../../context/auth';
import {getPlanStage} from '../../../utils/productAccess';

const ABOUT_ASSESSMENT_PATH = '/dq_pro/national-dashboard/overview/about-assessment';

// Direct-URL guard for National pages the sidebar hides for the user's plan
// stage (dashboard catalog; see NationalDashboardList). UX only.
const PlanGate = ({packages, children}) => {
    const {authUser} = useContext(AuthContext);
    if (!packages.includes(getPlanStage(authUser))) {
        return <Redirect to={ABOUT_ASSESSMENT_PATH}/>;
    }
    return children;
};

export default PlanGate;
